// removed by extract-text-webpack-plugin
module.exports = {"root":"Input__root___1YjuZ","label":"Input__label___XWyHw","input":"Input__input____73vA"};